export const MAIN_LABELS = {
  in_preparation: "In Preparation",
  upcoming: "Upcoming",
  ongoing: "Ongoing",
  complete: "Complete",
};
export const CONTRACT_LABELS = { not_signed: "Not Signed", signed: "Contract Signed" };
export const AD_LABELS = {
  not_started: "Not Started",
  editing: "Ad Editing in Progress",
  ready: "Ad Ready to Post",
  ongoing: "Ongoing",
  complete: "Complete",
};
export const AD_SHORT = {
  not_started: "Ad: Not Started",
  editing: "Ad: Editing",
  ready: "Ad: Ready",
  ongoing: "Ad: Ongoing",
  complete: "Ad: Complete",
};

export const MAIN_FILTERS = [
  ["non_complete", "Non Complete"],
  ["upcoming", "Upcoming"],
  ["ongoing", "Ongoing"],
  ["complete", "Complete"],
  ["all", "All"],
];
export const DEFAULT_MAIN_FILTER = "non_complete";

export const SORTS = [
  ["sale_date", "Sale Date"],
  ["sale_date_desc", "Sale Date (newest first)"],
  ["name", "Horse Name (A–Z)"],
  ["seller", "Seller Name (A–Z)"],
];

const dayKey = (v) => (/^\d{4}-\d{2}-\d{2}/.test(v || "") ? String(v).slice(0, 10) : null);
const todayKey = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const closeOf = (h) => dayKey(h.horse_info?.sale_close_date || h.sale_info?.sale_close_date);
const text = (v) => String(v || "").trim().toLowerCase();
const byText = (get) => (a, b) => {
  const x = text(get(a)), y = text(get(b));
  if (!x !== !y) return x ? -1 : 1;
  return x.localeCompare(y);
};
const desc = (a, b) => {
  const x = closeOf(a), y = closeOf(b);
  if (!x !== !y) return x ? -1 : 1;
  return x === y ? 0 : x < y ? 1 : -1;
};

export function sortHorses(list, sort, mainFilter) {
  const arr = [...list];
  if (sort === "name") return arr.sort(byText((h) => h.horse_info?.horse_name));
  if (sort === "seller") return arr.sort(byText((h) => h.seller_info?.customer_name));
  if (sort === "sale_date_desc" || mainFilter === "complete") return arr.sort(desc);
  const today = todayKey();
  return arr.sort((a, b) => {
    const x = closeOf(a), y = closeOf(b);
    if (!x !== !y) return x ? -1 : 1;
    if (!x) return 0;
    const fx = x >= today, fy = y >= today;
    if (fx !== fy) return fx ? -1 : 1;
    if (x === y) return 0;
    return fx ? (x < y ? -1 : 1) : (x < y ? 1 : -1);
  });
}

export const matchesMain = (ws, f) => {
  const m = ws?.main;
  if (f === "all") return true;
  if (f === "non_complete") return m !== "complete";
  return m === f;
};

export const MAIN_TONE = {
  in_preparation: "bg-orange-50 text-orange-800 border-orange-200",
  upcoming: "bg-blue-50 text-blue-800 border-blue-200",
  ongoing: "bg-emerald-50 text-emerald-800 border-emerald-200",
  complete: "bg-stone-900 text-white border-stone-900",
};
export const CONTRACT_TONE = {
  not_signed: "bg-white text-stone-700 border-stone-300",
  signed: "bg-emerald-50 text-emerald-800 border-emerald-200",
};
export const AD_TONE = {
  not_started: "bg-white text-stone-700 border-stone-300",
  editing: "bg-orange-50 text-orange-800 border-orange-200",
  ready: "bg-violet-50 text-violet-800 border-violet-200",
  ongoing: "bg-emerald-50 text-emerald-800 border-emerald-200",
  complete: "bg-stone-100 text-stone-800 border-stone-300",
};
